import { validate as isUuid } from 'uuid'

import {
    hasOwn,
    isNonEmptyString,
    isRecord,
    isValidV1EventEnvelope,
} from '@/utils/eventEnvelope'

const KICK_EVENT_TYPES = {
    REQUESTED: 'order.kick_requested',
    CONFIRMED: 'order.kick_confirmed',
}

const LEGACY_EVENT_TYPES = {
    CLOSED: 'order_closed',
    UPDATED: 'order_updated',
}

export const USER_ORDER_EVENT_KINDS = {
    KICK_REQUESTED: 'kickRequested',
    KICK_CONFIRMED: 'kickConfirmed',
    LEGACY_CLOSED: 'legacyClosed',
    LEGACY_UPDATED: 'legacyUpdated',
}

const KICK_EVENT_TYPE_SET = new Set(Object.values(KICK_EVENT_TYPES))

const normalizeLegacyPayload = data => {
    if (!isRecord(data)) return null

    const orderId =
        typeof data.order_id === 'string' ||
        (typeof data.order_id === 'number' && Number.isFinite(data.order_id))
            ? String(data.order_id).trim()
            : ''
    const notificationText = isNonEmptyString(data.message)
        ? data.message.trim()
        : ''

    return orderId && notificationText ? { orderId, notificationText } : null
}

const isValidKickPayload = (type, data) => {
    if (!isRecord(data) || !isUuid(data.order_id)) return false
    if (type === KICK_EVENT_TYPES.CONFIRMED) return true
    return (
        isNonEmptyString(data.initiator) &&
        ((typeof data.order_num === 'string' &&
            Boolean(data.order_num.trim())) ||
            (typeof data.order_num === 'number' &&
                Number.isFinite(data.order_num)))
    )
}

const isValidKickEnvelope = envelope =>
    isValidV1EventEnvelope(envelope, {
        eventTypes: KICK_EVENT_TYPE_SET,
        validateData: isValidKickPayload,
    })

export const classifyUserOrderEvent = data => {
    if (hasOwn(data, 'version')) {
        if (!isValidKickEnvelope(data)) {
            throw new TypeError(
                '[UserNotifications] Пропущено некорректное kick-событие'
            )
        }

        return {
            kind:
                data.type === KICK_EVENT_TYPES.REQUESTED
                    ? USER_ORDER_EVENT_KINDS.KICK_REQUESTED
                    : USER_ORDER_EVENT_KINDS.KICK_CONFIRMED,
            eventId: data.id,
            orderId: data.data.order_id,
            payload: data.data,
        }
    }

    if (hasOwn(data, 'event')) {
        // Легаси-конверт плоский: { event, message, order_id }.
        // Толерантность к вложенной форме { event, data: { order_id, message } }.
        const source = isRecord(data.data) ? data.data : data
        const payload = normalizeLegacyPayload(source)
        const kind = {
            [LEGACY_EVENT_TYPES.CLOSED]: USER_ORDER_EVENT_KINDS.LEGACY_CLOSED,
            [LEGACY_EVENT_TYPES.UPDATED]: USER_ORDER_EVENT_KINDS.LEGACY_UPDATED,
        }[data.event]

        if (!kind || !payload) {
            throw new TypeError(
                '[UserNotifications] Пропущено некорректное legacy order-событие'
            )
        }

        // У легаси-конверта нет поля id — дедупликация по содержимому
        const eventId = `legacy:${data.event}:${payload.orderId}:${payload.notificationText}`
        return { kind, payload, eventId }
    }

    return null
}
